import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  permitTemplateEditorKeys,
  RequestTypes,
} from '@core/react-query/features/templates/permitTemplateEditor'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IPermitTemplateVersion } from '@core/entities/permit-template-editor'

export const useUpdatePermitTemplateVersionPermitHolderQuestions = (
  options?: UseMutationOptions<
    IPermitTemplateVersion,
    RequestErrorType,
    RequestTypes['updatePermitTemplateVersionPermitHolderQuestions']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...permitTemplateEditorKeys.updatePermitHolderQuestions,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: permitTemplateEditorKeys._def,
      })
    },
  })
}
